import { get } from 'util/fetch';
import { configuration as configurationEndpoint } from '../../config/backendRoutes';

export const features = (token, organizationShortName) =>
  get(`${configurationEndpoint}/v1/${organizationShortName}/features`, { token });

export const featuresV2 = (token, organizationShortName) =>
  get(`${configurationEndpoint}/v2/${organizationShortName}/features`, { token });
